(() => {
const root = document.querySelector("[data-rolife-product-archive]");
if (!root || root.dataset.rpaInitialized === "true") return;

const configNode = root.querySelector("[data-rpa-config]");
if (!configNode) return;

let config;
try {
  config = JSON.parse(configNode.textContent);
} catch (error) {
  console.error("Unable to initialize the Rolife product archive.", error);
  return;
}

root.dataset.rpaInitialized = "true";

const previousDocumentOverflow = document.documentElement.style.overflow;
const previousBodyOverflow = document.body.style.overflow;
document.documentElement.style.overflow = "hidden";
document.body.style.overflow = "hidden";

const productCopy = {
  DG108: "Miller's Garden",
  DS010: "Sweet Jam Shop",
  DG155: "Kiki's Magic Emporium",
  DG109: "Simon's Coffee Shop",
  DGF03: "Party Time",
  DG12: "Dora's LOFT",
  DG157: "Mose's Detective Agency",
  DGM09: "Mrs Charlie's Dining Room",
  DGM07: "Jimmy's Studio",
  DS019: "Aroma Toast Lab",
  DS022: "Island Dream Villa",
  DS023: "Dark Castle",
  DS024: "Bear's Sweetie",
  DS026: "Sweet Forest",
  DS028: "Holiday Living Room",
  DS029: "Afternoon Baking Time",
  TG305: "Sailling Ship Model",
  TG306: "Cruise Ship Model",
  AMU01: "Enchanted Blossom Lantern",
  DG154: "Spring Encounter Flowers",
  DS012: "Dream Yard",
  DG147: "Light Music Bar",
  DG141: "Joy's Living Room",
};

const productYears = {
  DG108: "2020",
  DS010: "2021",
  DG155: "2024",
  DG109: "2020",
  DGF03: "2020",
  DG12: "2020",
  DG157: "2022",
  DGM09: "2020",
  DGM07: "2020",
  DS019: "2022",
  DS022: "2022",
  DS023: "2022",
  DS024: "2022",
  DS026: "2022",
  DS028: "2022",
  DS029: "2022",
  TG305: "2020",
  TG306: "2020",
  AMU01: "2021",
  DG154: "2021",
  DS012: "2021",
  DG147: "2021",
  DG141: "2020",
};

const productSkus = [
  "DG108",
  "DG154",
  "DGF03",
  "DGM07",
  "TG305",
  "AMU01",
  "DS023",
  "DS029",
  "DS024",
  "DS022",
  "DS012",
  "DS010",
  "DG157",
  "DS019",
  "DG155",
  "DG147",
  "TG306",
  "DS028",
  "DG12",
  "DGM09",
  "DG141",
  "DS026",
  "DG109",
];

const productPatternSkus = [
  "DGM07",
  "AMU01",
  "TG306",
  "DGF03",
  "DS023",
  "DG108",
  "DG147",
  "DS029",
  "DS024",
  "DS010",
  "DG154",
  "DS022",
  "DS026",
  "DG155",
  "DS028",
  "DS012",
  "DS019",
  "DGM09",
  "DG12",
  "DG141",
  "DG109",
  "TG305",
  "DG157",
];

const productPattern = Array.from({ length: productPatternSkus.length }, (_, columnIndex) =>
  Array.from(
    { length: productPatternSkus.length },
    (_, rowIndex) => productPatternSkus[wrapIndex(rowIndex * 7 + columnIndex * 5, productPatternSkus.length)]
  )
);

const patternColumnCount = productPattern.length;
const patternRowCount = productPattern[0].length;
const renderColumnCount = 10;
const renderRowCount = 10;

const productImageScales = {
  DG108: 0.72,
  DS010: 0.75,
  DG155: 0.7,
  DG109: 0.7,
  DGF03: 0.72,
  DG12: 0.72,
  DG157: 0.7,
  DGM09: 0.7,
  DGM07: 0.7,
  DS019: 0.78,
  DS022: 0.78,
  DS023: 0.75,
  DS024: 0.75,
  DS026: 0.74,
  DS028: 0.73,
  DS029: 0.73,
  TG305: 0.73,
  TG306: 0.72,
  AMU01: 0.72,
  DG154: 0.72,
  DS012: 0.72,
  DG147: 0.76,
  DG141: 0.72,
};

function wrapIndex(value, length) {
  return ((value % length) + length) % length;
}

function getProductByGrid(rowIndex, columnIndex) {
  const patternColumn = productPattern[wrapIndex(columnIndex, patternColumnCount)];
  const sku = patternColumn[wrapIndex(rowIndex, patternRowCount)];
  const name = productCopy[sku];
  return {
    sku,
    name,
    year: productYears[sku] ?? sku,
    image: config.products[sku].image,
    scene: config.products[sku].scene,
    scale: productImageScales[sku] ?? 0.72,
  };
}

const productSlots = Array.from({ length: renderColumnCount * renderRowCount });

const screen = root.querySelector(".rpa-product-screen");
const grid = root.querySelector("[data-rpa-grid]");
const introOverlay = root.querySelector(".rpa-intro-overlay");
const introContent = root.querySelector(".rpa-intro-content");
const introTitle = root.querySelector(".rpa-intro-title");
const pageClose = root.querySelector(".rpa-page-close");

grid.innerHTML = productSlots
  .map((_, slotIndex) => {
    const rowIndex = Math.floor(slotIndex / renderColumnCount);
    const columnIndex = slotIndex % renderColumnCount;
    const { sku, name, year, image, scene, scale } = getProductByGrid(rowIndex, columnIndex);
    const label = `${year} ${name}`;

    return `
      <article
        class="rpa-product-card"
        style="
          --scale: ${scale};
        "
      >
        <div class="rpa-product-card-inner" aria-hidden="true">
          <img class="rpa-product-frame" src="${config.frameUrl}" alt="" />
          <div class="rpa-product-scene-mask">
            <img class="rpa-product-scene-image" src="${scene}" alt="" loading="eager" draggable="false" />
          </div>
          <div class="rpa-product-image-wrap">
            <img class="rpa-product-image" src="${image}" alt="${label}" loading="eager" draggable="false" />
          </div>
        </div>
        <div class="rpa-product-label" aria-label="${label}">
          <span class="rpa-product-name">${name}</span>
          <span class="rpa-product-number">${year}</span>
        </div>
      </article>
    `;
  })
  .join("");

const cards = [...grid.querySelectorAll(".rpa-product-card")];
const cardInners = [...grid.querySelectorAll(".rpa-product-card-inner")];

productSkus.forEach((sku) => {
  [config.products[sku].image, config.products[sku].scene].forEach((src) => {
    const image = new Image();
    image.src = src;
  });
});

let dragX = 0;
let dragY = 0;
let startX = 0;
let startY = 0;
let baseX = 0;
let baseY = 0;
let lastX = 0;
let lastY = 0;
let isDragging = false;
let hasUserDragged = false;
let dragMoved = false;
let pointerStartCard = null;
let lastTapToggleAt = 0;
let suppressTapToggleUntil = 0;
let touchStartX = 0;
let touchStartY = 0;
let touchMoved = false;
let touchStartCard = null;
let isIntroOpen = Boolean(introOverlay && !introOverlay.classList.contains("is-hidden"));
let autoPanX = window.innerWidth / 2;
let autoPanY = window.innerHeight / 2;
let isAutoPanReady = false;
let autoPanFrame = 0;
let autoPanLastTime = 0;
let autoPanHoverStartedAt = performance.now();
let introEnterTimer = 0;
let introAutoTimer = 0;
let introGlitchTimer = 0;
let cachedCycleMetrics = null;
let renderFrame = 0;
let lastInteractionAt = performance.now();
let idleScrollFrame = 0;
let idleScrollLastTime = 0;
let idleScrollDistance = 0;
let idleScrollActive = false;
let pausedScrollColumn = null;
let pausedScrollOffset = 0;
let lastPointerX = window.innerWidth / 2;
let lastPointerY = window.innerHeight / 2;
let hasPointerPosition = false;
const autoPanDelay = 3000;
const introAutoDelay = 5000;
const idleScrollDelay = 3000;
const idleScrollSpeedDesktop = 30;
const idleScrollSpeedMobile = 20;
const autoPanMoveThreshold = 4;
const tapMoveThreshold = 8;
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function getMetrics() {
  const screenStyle = getComputedStyle(screen);
  const toNumber = (value) => Number(String(value).replace("px", "")) || 0;
  const padX = toNumber(screenStyle.paddingLeft) + toNumber(screenStyle.paddingRight);
  const padY = toNumber(screenStyle.paddingTop) + toNumber(screenStyle.paddingBottom);
  const visibleWidth = screen.clientWidth - padX;
  const visibleHeight = screen.clientHeight - padY;
  const gridRect = grid.getBoundingClientRect();
  const contentRects = [...grid.querySelectorAll(".rpa-product-card, .rpa-product-label")].map((item) =>
    item.getBoundingClientRect()
  );
  const content = contentRects.reduce(
    (box, rect) => ({
      minX: Math.min(box.minX, rect.left - gridRect.left),
      minY: Math.min(box.minY, rect.top - gridRect.top),
      maxX: Math.max(box.maxX, rect.right - gridRect.left),
      maxY: Math.max(box.maxY, rect.bottom - gridRect.top),
    }),
    { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity }
  );

  return {
    visibleWidth,
    visibleHeight,
    content,
  };
}

function getBounds() {
  const { visibleWidth, visibleHeight, content } = getMetrics();

  return {
    minX: visibleWidth - content.maxX,
    minY: visibleHeight - content.maxY,
    maxX: -content.minX,
    maxY: -content.minY,
  };
}

function applyDrag(options = {}) {
  if (options.immediate) {
    if (renderFrame) {
      cancelAnimationFrame(renderFrame);
      renderFrame = 0;
    }
    renderInfiniteGrid();
    return;
  }

  if (renderFrame) return;
  renderFrame = requestAnimationFrame(() => {
    renderFrame = 0;
    renderInfiniteGrid();
  });
}

function getCycleMetrics() {
  if (cachedCycleMetrics) return cachedCycleMetrics;

  const toNumber = (value) => Number(String(value).replace("px", "")) || 0;
  const rootStyle = getComputedStyle(root);
  const rootFontSize = toNumber(rootStyle.fontSize) || 16;
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const preferredGap = window.innerWidth * (isMobile ? 0.038 : 0.012);
  const minGap = rootFontSize * (isMobile ? 0.95 : 0.75);
  const maxGap = rootFontSize * 1.25;
  const firstCard = grid.querySelector(".rpa-product-card");
  const cardWidth = firstCard ? toNumber(getComputedStyle(firstCard).width) : 0;
  const cardHeight = cardWidth;
  const gap = clamp(preferredGap, minGap, maxGap);

  cachedCycleMetrics = {
    visibleWidth: grid.clientWidth,
    visibleHeight: grid.clientHeight,
    cardWidth,
    cardHeight,
    stepX: cardWidth + gap,
    stepY: cardHeight + gap,
    staggerY: cardHeight * -0.62,
    cycleWidth: patternColumnCount * (cardWidth + gap),
    cycleHeight: patternRowCount * (cardHeight + gap),
  };

  return cachedCycleMetrics;
}

function normalizeDrag() {
  const { cycleWidth, cycleHeight } = getCycleMetrics();
  if (cycleWidth > 0) {
    dragX = ((dragX % cycleWidth) + cycleWidth) % cycleWidth;
    if (dragX > 0) dragX -= cycleWidth;
  }
  if (cycleHeight > 0) {
    dragY = ((dragY % cycleHeight) + cycleHeight) % cycleHeight;
    if (dragY > 0) dragY -= cycleHeight;
  }
}

function updateCardProduct(card, product) {
  if (card.dataset.sku === product.sku) return;
  const displayNumber = product.year ?? product.sku;
  const label = `${displayNumber} ${product.name}`;
  const sceneImage = card.querySelector(".rpa-product-scene-image");
  const productImage = card.querySelector(".rpa-product-image");
  const productLabel = card.querySelector(".rpa-product-label");
  const productName = card.querySelector(".rpa-product-name");
  const productNumber = card.querySelector(".rpa-product-number");

  card.dataset.sku = product.sku;
  card.style.setProperty("--scale", product.scale);
  productLabel?.setAttribute("aria-label", label);
  if (sceneImage) {
    sceneImage.src = product.scene;
  }
  if (productImage) {
    productImage.src = product.image;
    productImage.alt = label;
  }
  if (productName) {
    productName.textContent = product.name;
  }
  if (productNumber) {
    productNumber.textContent = displayNumber;
  }
}

function getLiveColumnScrollOffset(columnIndex) {
  const direction = Math.abs(columnIndex % 2) === 0 ? -1 : 1;
  return direction * idleScrollDistance;
}

function getColumnScrollOffset(columnIndex) {
  if (pausedScrollColumn === columnIndex) {
    return pausedScrollOffset;
  }
  return getLiveColumnScrollOffset(columnIndex);
}

function updatePointerPosition(event) {
  lastPointerX = event.clientX;
  lastPointerY = event.clientY;
  hasPointerPosition = true;
}

function updatePausedScrollColumnFromPoint(x, y) {
  if (!idleScrollActive || isIntroOpen || isDragging || isTapViewport()) {
    pausedScrollColumn = null;
    syncPausedColumnClasses();
    return null;
  }

  const targetCard = document.elementFromPoint(x, y)?.closest?.(".rpa-product-card");
  if (!targetCard || !grid.contains(targetCard)) {
    pausedScrollColumn = null;
    syncPausedColumnClasses();
    clearHoverSpread();
    return null;
  }

  const column = Number(targetCard.dataset.gridColumn);
  if (!Number.isFinite(column)) {
    pausedScrollColumn = null;
    syncPausedColumnClasses();
    clearHoverSpread();
    return null;
  }

  if (pausedScrollColumn !== column) {
    pausedScrollColumn = column;
    pausedScrollOffset = getLiveColumnScrollOffset(column);
  }
  syncPausedColumnClasses();
  if (!targetCard.classList.contains("is-hovered")) {
    applyHoverSpread(targetCard, { force: true });
  }
  return targetCard;
}

function syncPausedColumnClasses() {
  cards.forEach((card) => {
    const column = Number(card.dataset.gridColumn);
    card.classList.toggle(
      "is-paused-column",
      idleScrollActive && Number.isFinite(column) && pausedScrollColumn === column
    );
  });
}

function recordInteraction() {
  lastInteractionAt = performance.now();
  idleScrollLastTime = 0;
  idleScrollActive = false;
  pausedScrollColumn = null;
  screen.classList.remove("is-row-scrolling");
  syncPausedColumnClasses();
}

function renderInfiniteGrid() {
  const { cardWidth, cardHeight, stepX, stepY, staggerY } = getCycleMetrics();
  if (!stepX || !stepY) return;

  const bufferColumns = 3;
  const bufferRows = 3;
  const startColumn = Math.floor((-dragX - cardWidth) / stepX) - bufferColumns;
  let slotIndex = 0;

  for (let columnSlot = 0; columnSlot < renderColumnCount; columnSlot += 1) {
    const worldColumn = startColumn + columnSlot;
    const columnStagger = Math.abs(worldColumn % 2) === 1 ? staggerY : 0;
    const columnScroll = getColumnScrollOffset(worldColumn);
    const startRow = Math.floor((-dragY - columnStagger - columnScroll - cardHeight) / stepY) - bufferRows;

    for (let rowSlot = 0; rowSlot < renderRowCount; rowSlot += 1) {
      const card = cards[slotIndex];
      if (!card) return;
      const worldRow = startRow + rowSlot;
      const product = getProductByGrid(worldRow, worldColumn);
      const tileX = worldColumn * stepX + dragX;
      const tileY = worldRow * stepY + columnStagger + dragY + columnScroll;
      const introDelay = Math.min(620, rowSlot * 34 + columnSlot * 18);

      card.dataset.gridColumn = String(worldColumn);
      card.dataset.gridRow = String(worldRow);
      card.classList.toggle("is-paused-column", idleScrollActive && pausedScrollColumn === worldColumn);
      card.style.setProperty("--tile-x", `${tileX}px`);
      card.style.setProperty("--tile-y", `${tileY}px`);
      card.style.setProperty("--intro-delay", `${introDelay}ms`);
      updateCardProduct(card, product);
      slotIndex += 1;
    }
  }
}

function setProductFollow(moveX, moveY) {
  const followX = clamp(moveX * 0.045, -0.9, 0.9);
  const followY = clamp(moveY * 0.045, -0.9, 0.9);
  const followR = clamp(moveX * 0.004 + moveY * 0.0015, -0.09, 0.09);

  cardInners.forEach((inner, index) => {
    const factor = 0.72 + (index % 5) * 0.055;
    const verticalFactor = 0.68 + (index % 4) * 0.05;
    const rotateFactor = index % 2 === 0 ? 1 : 0.82;
    inner.style.setProperty("--follow-x", `${(followX * factor).toFixed(3)}px`);
    inner.style.setProperty("--follow-y", `${(followY * verticalFactor).toFixed(3)}px`);
    inner.style.setProperty("--follow-r", `${(followR * rotateFactor).toFixed(4)}deg`);
  });
}

function resetProductFollow() {
  cardInners.forEach((inner) => {
    inner.style.setProperty("--follow-x", "0px");
    inner.style.setProperty("--follow-y", "0px");
    inner.style.setProperty("--follow-r", "0deg");
  });
}

function clearHoverSpread(options = {}) {
  const keepCard = options.keepCard ?? null;
  cards.forEach((card) => {
    card.classList.toggle("is-hovered", card === keepCard);
    card.style.setProperty("--push-x", "0px");
    card.style.setProperty("--push-y", "0px");
    card.style.setProperty("--push-delay", "0ms");
  });
}

function applyHoverSpread(targetCard, options = {}) {
  if ((isDragging || idleScrollActive) && !options.force) return;

  const targetColumn = Number(targetCard.dataset.gridColumn) || 0;
  const targetRow = Number(targetCard.dataset.gridRow) || 0;
  const targetRect = targetCard.getBoundingClientRect();
  const targetX = targetRect.left + targetRect.width / 2;
  const targetY = targetRect.top + targetRect.height / 2;
  const cardSize = targetRect.width || Number.parseFloat(getComputedStyle(targetCard).width) || 1;
  const axisThreshold = cardSize * 0.35;
  const push = cardSize * (window.matchMedia("(max-width: 767px)").matches ? 0.026 : 0.028);

  cards.forEach((card, index) => {
    const isTarget = card === targetCard;
    card.classList.toggle("is-hovered", isTarget);

    if (isTarget) {
      card.style.setProperty("--push-x", "0px");
      card.style.setProperty("--push-y", "0px");
      card.style.setProperty("--push-delay", "0ms");
      return;
    }

    const columnDistance = Math.abs((Number(card.dataset.gridColumn) || 0) - targetColumn);
    const rowDistance = Math.abs((Number(card.dataset.gridRow) || 0) - targetRow);
    const ring = Math.max(columnDistance, rowDistance);
    const rect = card.getBoundingClientRect();
    const dx = rect.left + rect.width / 2 - targetX;
    const dy = rect.top + rect.height / 2 - targetY;

    card.style.setProperty("--push-x", `${Math.abs(dx) > axisThreshold ? Math.sign(dx) * push : 0}px`);
    card.style.setProperty("--push-y", `${Math.abs(dy) > axisThreshold ? Math.sign(dy) * push : 0}px`);
    card.style.setProperty("--push-delay", `${Math.min(ring, 4) * 46}ms`);
  });
}

function isTapViewport() {
  return window.matchMedia("(hover: none), (pointer: coarse)").matches;
}

function isSelectableTextTarget(target) {
  return Boolean(target.closest?.(".rpa-selectable-text"));
}

function toggleTapCard(card) {
  if (!card) return;
  lastTapToggleAt = performance.now();

  if (card.classList.contains("is-hovered")) {
    clearHoverSpread();
    return;
  }

  applyHoverSpread(card, { force: true });
}

function settleIntoBounds() {
  normalizeDrag();
  applyDrag();
}

function updateAutoPanPoint(event) {
  const moved = Math.hypot(event.clientX - autoPanX, event.clientY - autoPanY) > autoPanMoveThreshold;
  autoPanX = event.clientX;
  autoPanY = event.clientY;
  if (!isAutoPanReady || moved) {
    autoPanHoverStartedAt = performance.now();
  }
  isAutoPanReady = true;
}

function getAutoPanVelocity() {
  const rect = screen.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  const distanceX = (autoPanX - centerX) / (rect.width / 2);
  const distanceY = (autoPanY - centerY) / (rect.height / 2);
  const deadZone = 0.18;
  const maxSpeed = window.matchMedia("(max-width: 767px)").matches ? 14 : 20;
  const axisSpeed = (distance) => {
    const direction = Math.sign(distance);
    const strength = Math.max(0, (Math.abs(distance) - deadZone) / (1 - deadZone));
    return direction * strength * strength * maxSpeed;
  };

  return {
    x: axisSpeed(clamp(distanceX, -1, 1)),
    y: axisSpeed(clamp(distanceY, -1, 1)),
  };
}

function autoPan(time = performance.now()) {
  const delta = Math.min(32, time - (autoPanLastTime || time));
  autoPanLastTime = time;

  if (!isIntroOpen && !isDragging && isAutoPanReady) {
    if (time - autoPanHoverStartedAt < autoPanDelay) {
      autoPanFrame = requestAnimationFrame(autoPan);
      return;
    }

    const bounds = getBounds();
    const velocity = getAutoPanVelocity();
    const nextX = clamp(dragX + (velocity.x * delta) / 1000, bounds.minX, bounds.maxX);
    const nextY = clamp(dragY + (velocity.y * delta) / 1000, bounds.minY, bounds.maxY);
    const moveX = nextX - dragX;
    const moveY = nextY - dragY;

    dragX = nextX;
    dragY = nextY;

    if (Math.abs(moveX) > 0.01 || Math.abs(moveY) > 0.01) {
      applyDrag();
      setProductFollow(moveX * 12, moveY * 12);
    } else {
      resetProductFollow();
    }
  }

  autoPanFrame = requestAnimationFrame(autoPan);
}

function startAutoPan() {
  if (autoPanFrame) return;
  autoPanLastTime = 0;
  autoPanFrame = requestAnimationFrame(autoPan);
}

function animateIdleRows(time = performance.now()) {
  const shouldScroll = !isIntroOpen && !isDragging && time - lastInteractionAt >= idleScrollDelay;

  if (shouldScroll) {
    if (!idleScrollActive) {
      idleScrollActive = true;
      idleScrollLastTime = time;
      const pausedCard = hasPointerPosition ? updatePausedScrollColumnFromPoint(lastPointerX, lastPointerY) : null;
      screen.classList.add("is-row-scrolling");
      resetProductFollow();
      if (!pausedCard) clearHoverSpread();
    }

    const delta = Math.min(42, time - (idleScrollLastTime || time));
    const { cycleHeight } = getCycleMetrics();
    const speed = window.matchMedia("(max-width: 767px)").matches ? idleScrollSpeedMobile : idleScrollSpeedDesktop;

    idleScrollLastTime = time;
    idleScrollDistance += (speed * delta) / 1000;
    if (cycleHeight > 0) {
      idleScrollDistance = ((idleScrollDistance % cycleHeight) + cycleHeight) % cycleHeight;
    }
    if (renderFrame) {
      cancelAnimationFrame(renderFrame);
      renderFrame = 0;
    }
    renderInfiniteGrid();
  } else {
    idleScrollActive = false;
    idleScrollLastTime = 0;
    screen.classList.remove("is-row-scrolling");
  }

  idleScrollFrame = requestAnimationFrame(animateIdleRows);
}

function clearIntroAutoEnter() {
  window.clearTimeout(introAutoTimer);
  introAutoTimer = 0;
}

function stopIntroGlitchOut(options = {}) {
  if (introGlitchTimer) {
    window.clearTimeout(introGlitchTimer);
    introGlitchTimer = 0;
  }
  introOverlay?.classList.remove("is-glitching");
  if (options.complete) {
    introContent?.style.setProperty("--intro-title-opacity", "0");
    introContent?.style.setProperty("--intro-title-filter", "blur(1px)");
  }
}

function playIntroGlitchOut(onComplete) {
  if (!introTitle || !introOverlay) return;
  stopIntroGlitchOut();
  introOverlay.classList.add("is-glitching");

  introGlitchTimer = window.setTimeout(() => {
    stopIntroGlitchOut({ complete: true });
    window.setTimeout(() => {
      onComplete?.();
    }, 90);
  }, 620);
}

function scheduleIntroAutoEnter() {
  clearIntroAutoEnter();
  if (!isIntroOpen) return;
  introAutoTimer = window.setTimeout(() => {
    enterPage();
  }, introAutoDelay);
}

function applyIntroFadeOutStyles() {
  stopIntroGlitchOut({ complete: true });
  introOverlay?.style.setProperty("--intro-bg-alpha", "0");
  introContent?.style.setProperty("--intro-title-opacity", "0");
  introContent?.style.setProperty("--intro-title-filter", "blur(1px)");
}

function finishEnterPage() {
  isIntroOpen = false;
  lastInteractionAt = performance.now();
  idleScrollLastTime = 0;
  idleScrollActive = false;
  screen.classList.remove("is-intro");
  introOverlay?.classList.add("is-hidden");
  pageClose?.classList.add("is-visible");
  introEnterTimer = 0;
}

function createTapSpark(event) {
  if (!introOverlay || !event) return;
  const spark = document.createElement("span");
  spark.className = "rpa-tap-spark";
  spark.style.setProperty("--spark-x", `${event.clientX}px`);
  spark.style.setProperty("--spark-y", `${event.clientY}px`);

  [0, 54, 112, 185, 244, 306].forEach((angle, index) => {
    const ray = document.createElement("i");
    ray.style.setProperty("--spark-angle", `${angle}deg`);
    ray.style.setProperty("--spark-size", `${10 + (index % 3) * 4}px`);
    ray.style.setProperty("--spark-distance", `${18 + (index % 2) * 8}px`);
    spark.append(ray);
  });

  introOverlay.append(spark);
  window.setTimeout(() => spark.remove(), 620);
}

function enterPage(event) {
  if (event && isSelectableTextTarget(event.target)) return;
  clearIntroAutoEnter();
  if (introOverlay?.classList.contains("is-leaving")) return;
  if (event) {
    updatePointerPosition(event);
    updateAutoPanPoint(event);
  }
  window.clearTimeout(introEnterTimer);
  introOverlay?.classList.add("is-leaving");
  introEnterTimer = window.setTimeout(finishEnterPage, reducedMotion.matches ? 140 : 680);
}

function centerContent() {
  const { visibleWidth, cardWidth, stepX, stepY } = getCycleMetrics();
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  dragX = isMobile ? (visibleWidth - cardWidth) / 2 - stepX : -stepX * 0.68;
  dragY = -stepY * 0.42;
  normalizeDrag();
  applyDrag({ immediate: true });
}

screen.addEventListener("pointerdown", (event) => {
  if (isSelectableTextTarget(event.target)) return;
  updatePointerPosition(event);
  recordInteraction();
  updateAutoPanPoint(event);
  pointerStartCard = event.target.closest?.(".rpa-product-card") ?? null;
  dragMoved = false;
  if (isTapViewport() && pointerStartCard?.classList.contains("is-hovered")) {
    clearHoverSpread();
    lastTapToggleAt = performance.now();
    suppressTapToggleUntil = performance.now() + 350;
    pointerStartCard = null;
  }
  if (!isTapViewport() || !pointerStartCard) {
    clearHoverSpread();
  }
  isDragging = true;
  hasUserDragged = true;
  startX = event.clientX;
  startY = event.clientY;
  lastX = event.clientX;
  lastY = event.clientY;
  baseX = dragX;
  baseY = dragY;
  screen.classList.add("is-dragging");
  screen.setPointerCapture(event.pointerId);
});

screen.addEventListener("pointermove", (event) => {
  if (isSelectableTextTarget(event.target)) return;
  updatePointerPosition(event);
  if (idleScrollActive && !isDragging) {
    updatePausedScrollColumnFromPoint(event.clientX, event.clientY);
    return;
  }
  recordInteraction();
  updateAutoPanPoint(event);
  if (!isDragging) return;
  if (Math.hypot(event.clientX - startX, event.clientY - startY) > tapMoveThreshold) {
    dragMoved = true;
    if (isTapViewport()) {
      pointerStartCard = null;
      clearHoverSpread();
    }
  }
  dragX += event.clientX - lastX;
  dragY += event.clientY - lastY;
  normalizeDrag();
  applyDrag();
  resetProductFollow();
  lastX = event.clientX;
  lastY = event.clientY;
});

function endDrag(event) {
  if (!isDragging) return;
  const tapCard = !dragMoved && !isTapViewport() ? pointerStartCard : null;
  isDragging = false;
  recordInteraction();
  autoPanHoverStartedAt = performance.now();
  screen.classList.remove("is-dragging");
  if (screen.hasPointerCapture(event.pointerId)) {
    screen.releasePointerCapture(event.pointerId);
  }
  resetProductFollow();
  toggleTapCard(tapCard);
  pointerStartCard = null;
}

screen.addEventListener("pointerup", endDrag);
screen.addEventListener("pointercancel", endDrag);
screen.addEventListener("pointerleave", () => {
  isAutoPanReady = false;
  pausedScrollColumn = null;
  clearHoverSpread();
  resetProductFollow();
  recordInteraction();
});

screen.addEventListener("click", (event) => {
  if (isSelectableTextTarget(event.target)) return;
  recordInteraction();
  if (!isTapViewport() || dragMoved || performance.now() - lastTapToggleAt < 350) return;
  const targetCard =
    event.target.closest?.(".rpa-product-card") ??
    document.elementFromPoint(event.clientX, event.clientY)?.closest?.(".rpa-product-card");
  if (!targetCard || !grid.contains(targetCard)) return;
  event.preventDefault();
  toggleTapCard(targetCard);
});

screen.addEventListener(
  "touchstart",
  (event) => {
    if (!isTapViewport() || event.touches.length !== 1) return;
    if (isSelectableTextTarget(event.target)) return;
    recordInteraction();
    const touch = event.touches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    touchMoved = false;
    touchStartCard = document.elementFromPoint(touch.clientX, touch.clientY)?.closest?.(".rpa-product-card") ?? null;
  },
  { passive: true }
);

screen.addEventListener(
  "touchmove",
  (event) => {
    if (!touchStartCard || event.touches.length !== 1) return;
    const touch = event.touches[0];
    recordInteraction();
    if (Math.hypot(touch.clientX - touchStartX, touch.clientY - touchStartY) <= tapMoveThreshold) return;
    touchMoved = true;
    touchStartCard = null;
    clearHoverSpread();
  },
  { passive: true }
);

screen.addEventListener(
  "touchend",
  (event) => {
    recordInteraction();
    const touch = event.changedTouches[0];
    const endCard = touch
      ? document.elementFromPoint(touch.clientX, touch.clientY)?.closest?.(".rpa-product-card")
      : null;
    const tapCard = touchStartCard || endCard;
    touchStartCard = null;
    if (!isTapViewport() || touchMoved || !tapCard || performance.now() - lastTapToggleAt < 350) {
      touchStartCard = null;
      return;
    }
    window.setTimeout(() => toggleTapCard(tapCard), 0);
  },
  { passive: true }
);

cards.forEach((card) => {
  card.addEventListener("pointerenter", () => {
    if (!isTapViewport()) {
      applyHoverSpread(card);
    }
  });
  card.addEventListener("pointerleave", (event) => {
    if (isTapViewport()) return;
    const nextCard = event.relatedTarget?.closest?.(".rpa-product-card");
    if (nextCard && grid.contains(nextCard)) return;
    clearHoverSpread();
  });
  card.addEventListener("click", (event) => {
    if (!isTapViewport() || dragMoved || performance.now() - lastTapToggleAt < 350) return;
    event.preventDefault();
    toggleTapCard(card);
  });
  card.addEventListener("touchend", (event) => {
    const touch = event.changedTouches[0];
    const moved = touch ? Math.hypot(touch.clientX - touchStartX, touch.clientY - touchStartY) > tapMoveThreshold : false;
    if (!isTapViewport() || moved || performance.now() < suppressTapToggleUntil) return;
    event.preventDefault();
    event.stopPropagation();
    toggleTapCard(card);
  });
});

window.addEventListener("resize", () => {
  cachedCycleMetrics = null;
  if (hasUserDragged) {
    settleIntoBounds();
    return;
  }
  centerContent();
});
centerContent();
scheduleIntroAutoEnter();

introOverlay?.addEventListener("pointerdown", (event) => {
  enterPage(event);
});

document.addEventListener(
  "shopify:section:unload",
  (event) => {
    if (!event.target?.contains(root)) return;
    document.documentElement.style.overflow = previousDocumentOverflow;
    document.body.style.overflow = previousBodyOverflow;
  },
  { once: true }
);
})();

